import { useTheme } from 'foundations-theming/utils';
import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H7 from 'UIComponents/elements/headings/H7';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextArea from 'UIComponents/input/UITextArea';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { AiGenerationRating } from 'automation-ui-enrollment/components/aiAssistant/constants/AiGenerationRating';
import FeedbackRatingButton from 'automation-ui-enrollment/components/aiAssistant/FeedbackRatingButton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function FeedbackForm({
  heading,
  isLoading = false,
  onSubmit
}) {
  const trellisTheme = useTheme();
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [rating, setRating] = useState();
  const [comment, setComment] = useState('');
  if (feedbackSubmitted && !isLoading) {
    return /*#__PURE__*/_jsx(View, {
      marginBlock: "500",
      as: "div",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.aiAssistantFeedbackFooter.feedbackReceived"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(H7, {
      "aria-level": 4,
      className: "text-center m-y-5",
      children: heading
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-row justify-center",
      children: [/*#__PURE__*/_jsx(FeedbackRatingButton, {
        selected: rating === AiGenerationRating.THUMBS_UP,
        onClick: () => setRating(AiGenerationRating.THUMBS_UP),
        color: trellisTheme.color['do-not-use-oz-dark'],
        icon: "emoji",
        filledIcon: "emojiFillHappy",
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.aiAssistantFeedbackFooter.ratingButtons.satisfied"
        })
      }), /*#__PURE__*/_jsx(FeedbackRatingButton, {
        selected: rating === AiGenerationRating.THUMBS_DOWN,
        onClick: () => setRating(AiGenerationRating.THUMBS_DOWN),
        color: trellisTheme.color['do-not-use-candy-apple-dark'],
        icon: "emojiLineSad",
        filledIcon: "emojiFillSad",
        tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.aiAssistantFeedbackFooter.ratingButtons.dissatisfied"
        })
      })]
    }), rating && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.aiAssistantFeedbackFooter.feedbackForm.label"
        }),
        help: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.aiAssistantFeedbackFooter.feedbackForm.help"
        }),
        children: /*#__PURE__*/_jsx(UITextArea, {
          use: "on-dark",
          autoFocus: true,
          rows: 6,
          value: comment,
          onChange: event => setComment(event.target.value),
          placeholder: I18n.text('automation-ui-enrollment.aiAssistantFeedbackFooter.feedbackForm.placeholder')
        })
      }), /*#__PURE__*/_jsx(UILoadingButton, {
        className: "m-y-5",
        loading: isLoading,
        onClick: () => {
          onSubmit(rating, comment);
          setFeedbackSubmitted(true);
        },
        size: "small",
        use: "tertiary",
        type: "submit",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.aiAssistantFeedbackFooter.feedbackForm.sendFeedback"
        })
      })]
    })]
  });
}